import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import LanguageSwitcher from '../components/LanguageSwitcher';
import T from '../components/T';
import FacebookLogin from '../facebook/LoginButton';
import FacebookProvider from '../facebook/FacebookProvider';
import forceRerenderParent from '../components/forceRerenderParent';
import FloatingHeader from '../components/FloatingHeader';
import Tooltip from '../components/Tooltip';
import Label from '../components/Label';

class Form extends React.Component {
  static contextTypes = {
    t: PropTypes.func
  };

  formState = FormState.create(this);
  state = {};

  constructor(props) {
    super(props);

    this.state = this.formState.injectModel(props.form);
  }

  onAgreeToTermsAndConditions = ({ target: { tagName } }) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('agreeToTermsAndConditions');
    fieldState.setValue(+fieldState.getValue('agreeToTermsAndConditions') ^ 1).validate();
    context.updateFormState();
  };

  onAffirmDataProcessing = ({ target: { tagName } }) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('affirmDataProcessing');
    fieldState.setValue(+fieldState.getValue('affirmDataProcessing') ^ 1).validate();
    context.updateFormState();
  };

  onIsCompanyLabelClick = (e) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (e.target.tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('isCompany');
    fieldState.setValue(+fieldState.getValue('isCompany') ^ 1).validate();
    this.isCompany = (!this.isCompany);
    context.updateFormState();
  };

  onRequestedMatching = ({ target: { tagName } }) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('requestedMatching');
    fieldState.setValue(+fieldState.getValue('requestedMatching') ^ 1).validate();
    this.requestedMatching = (!this.requestedMatching);
    context.updateFormState();
  };

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork(); // this is so java
    context.set(name, value).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { t } = this.context;
    const { formDisabled, serverErrors, targetAmount, recaptcha } = this.props;
    const errors = populateFormErrors(this.formState, serverErrors);

    const isCompany = false;
    const requestedMatching = false;

    return (
      <section className="new-campaign">
        <div className="c-floating">
          <FloatingHeader rightChild={<LanguageSwitcher />} />

          <FormStateForm formState={this.formState} className="c-floating__body" onSubmit={this.onSubmit}>
            <fieldset disabled={formDisabled}>
              <h1 className="new-campaign__header">
                3 kroky za 5 minút na&nbsp;vytvorenie darovacej výzvy
              </h1>

              <p className="para">
                Vytvorte si vlastnú darcovskú výzvu, šírte ju medzi svojimi priateľmi a známymi a pomôžte nám získať ďalšie dary. Ďakujeme!
              </p>

              <div className="expander--1-2" />

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="campaignCreator.form.labels.campaignName" />
                </span>

                <span className="text-icon">
                  <span className="text-icon__text new-campaign__input-text">
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.campaignName }
                    )}>
                      <WiredInput
                        name="campaignName"
                        className="c-input"
                        autoFocus
                        onChange={this.onInputChange}
                        validator={v => v
                          .required().msg('campaignCreator.form.errors.campaignName.required')
                          .minLength(10).msg('campaignCreator.form.errors.campaignName.minLength')
                        }
                      />
                    </span>
                  </span>
                  <span className="text-icon__icon">
                    <Tooltip position="left" text={t('campaignCreator.form.labels.campaignNameHelp')}>
                      <i className="icon-question" />
                    </Tooltip>
                  </span>
                </span>
                <ValidationMessage msg={errors.campaignName} />
              </label>

              <Label className="c-checkbox" onClick={this.onIsCompanyLabelClick}>
                <WiredInput
                  type="checkbox"
                  name="isCompany"
                  defaultValue={0}
                  className="c-checkbox__input"
                />
                <i className="icon-checkbox c-checkbox__icon" />
                <span className="c-checkbox__text">
                    <T msg="campaignCreator.form.labels.isCompany" />
                  </span>
              </Label>

              <div className={this.isCompany ? 'show': 'hide'}>
                <label className="c-input__wrapper">
                  <span className="c-input__label">
                    <T msg="campaignCreator.form.labels.companyName" />
                  </span>

                    <span className="text-icon">
                    <span className="text-icon__text new-campaign__input-text">
                      <span className={classNames(
                        'c-input__border',
                        { 'c-input__border--error': errors.companyName }
                      )}>
                        <WiredInput
                          name="companyName"
                          className="c-input"
                          autoFocus
                          onChange={this.onInputChange}
                          // validator={v => v
                          //   .required().msg('campaignCreator.form.errors.companyName.required')
                          //   .minLength(1).msg('campaignCreator.form.errors.companyName.minLength')
                          // }
                        />
                      </span>
                    </span>
                  </span>
                    <ValidationMessage msg={errors.companyName} />
                </label>

                <Label className="c-checkbox" onClick={this.onRequestedMatching}>
                  <WiredInput
                    type="checkbox"
                    name="requestedMatching"
                    defaultValue={0}
                    className="c-checkbox__input"
                  />
                  <i className="icon-checkbox c-checkbox__icon" />
                  <span className="c-checkbox__text">
                    <T msg="campaignCreator.form.labels.requestedMatching" />
                  </span>
                  <span >

                  </span>
                </Label>
              </div>

              <div className={this.requestedMatching ? 'show': 'hide'}>
                <p>Ďakujeme, čoskoro sa Vám ozveme.</p>
                <br />
              </div>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="campaignCreator.form.labels.targetAmount" />
                </span>
                <span className="text-icon">
                  <span className="text-icon__text new-campaign__input-price">
                    <span className={classNames(
                      'c-input__border',
                      { 'c-input__border--error': errors.targetAmount }
                    )}>
                      <WiredInput
                        name="targetAmount"
                        className="c-input"
                        type="number"
                        min={window.DRJM.config.minimalTargetAmount}
                        step="1"
                        defaultValue={targetAmount}
                        validator={v => v
                          .required().msg('campaignCreator.form.errors.targetAmount.required')
                          .min(window.DRJM.config.minimalTargetAmount).msg('campaignCreator.form.errors.targetAmount.min')
                        }
                        onChange={this.onInputChange}
                      />
                      <span className="c-input__flag">&euro;</span>
                    </span>
                  </span>
                  <span className="text-icon__icon">
                    <Tooltip position="left" text={t('campaignCreator.form.labels.targetAmountHelp')}>
                      <i className="icon-question" />
                    </Tooltip>
                  </span>
                </span>
                <ValidationMessage msg={errors.targetAmount} />
              </label>

              <Label className="c-checkbox c-checkbox--no-margin" onClick={this.onAgreeToTermsAndConditions}>
                <WiredInput
                  type="checkbox"
                  name="agreeToTermsAndConditions"
                  defaultValue={0}
                  className="c-checkbox__input"
                  validator={v => v
                    .equals('1').msg('campaignCreator.form.errors.agreeToTermsAndConditions.equals')
                  }
                />
                <i className="icon-checkbox c-checkbox__icon" />
                <span className="c-checkbox__text">
                  <T msg="campaignCreator.form.labels.agreeTo" />
                  <a href="https://darujme.sk/pravidla-a-podmienky/" className="u-underline" target="_blank">
                    <T msg="campaignCreator.form.labels.termsAndConditions" />
                  </a>
                </span>
              </Label>
              <ValidationMessage msg={errors.agreeToTermsAndConditions} />

              <Label className="c-checkbox c-checkbox--no-margin" onClick={this.onAffirmDataProcessing} style={{ marginTop: '10px' }}>
                <WiredInput
                  type="checkbox"
                  name="affirmDataProcessing"
                  defaultValue={0}
                  className="c-checkbox__input"
                  validator={v => v
                    .equals('1').msg('campaignCreator.form.errors.affirmDataProcessing.equals')
                  }
                />
                <i className="icon-checkbox c-checkbox__icon" />
                <span className="c-checkbox__text">
                  <T msg="campaignCreator.form.labels.affirmThat" />
                  <a href="https://darujme.sk/pravidla-ochrany-osobnych-udajov/" className="u-underline" target="_blank">
                    <T msg="campaignCreator.form.labels.beenInformedDataProcessing" />
                  </a>
                </span>
              </Label>
              <ValidationMessage msg={errors.affirmDataProcessing} />

              <div className="expander" />

              <button type="submit"
                      className="c-button c-button--primary new-campaign__button"
                      data-sitekey={recaptcha}
                      data-callback='onSubmit'
                      data-action='submit'
              >
                <span className="c-button__content">
                  <span className="text-icon">
                    <span className="text-icon__text">
                      {window.DRJM.user ? <T msg="campaignCreator.form.actions.createCampaign" /> : <T msg="campaignCreator.form.actions.continue" />}
                    </span>
                    <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                </span>
              </button>

              <p className="para">
                <a href="https://darujme.sk/funkcie/peer-2-peer-fundraising/co-su-darcovske-vyzvy/" className="u-underline" target="_blank">
                  Čo sú darovacie výzvy?
                </a>
                <br />
                <a href="https://darujme.sk/funkcie/peer-2-peer-fundraising/uspesna-darcovska-vyzva-krok-za-krokom/" className="u-underline" target="_blank">
                  Úspešná kampaň krok za krokom
                </a>
              </p>
            </fieldset>
          </FormStateForm>
        </div>

        <div style={{ display: 'none' }}>
          <FacebookProvider>
            <FacebookLogin />
          </FacebookProvider>
        </div>
      </section>
    );
  }
}

export default forceRerenderParent(Form);



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignCreator/Form.js